import { Box } from '@mui/material';
import { useState, useEffect } from 'react';

import IconBox from '../logo-box';
import ContentBox from '../content-box';

const separator = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/separator.png`;
const timeline2007Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2007-1x.webp`;
const timeline2010Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2010-1x.webp`;
const timeline2016Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2016-1x.webp`;
const timeline2021Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2021-1x.webp`;
const timeline2024Img = `${process.env.REACT_APP_BASE_URL}/img/static/home-page/timeline-2024-1x.webp`;

const timelineRowStyle = { display: 'flex', gap: '24px' };

const MaybeFade = ({ children, ...props }) => {
    const [FadeComp, setFadeComp] = useState(null);

    useEffect(() => {
        let mounted = true;
        if (typeof window === 'undefined') {
            // keep return type consistent for ESLint
            return () => {
                mounted = false;
            };
        }

        import('react-awesome-reveal')
            .then((m) => {
                if (mounted && m && m.Fade) setFadeComp(() => m.Fade);
            })
            .catch(() => {});

        return () => {
            mounted = false;
        };
    }, []);

    if (FadeComp) return <FadeComp {...props}>{children}</FadeComp>;
    return <>{children}</>;
};

const MobileView = () => (
    <Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle }}>
                <IconBox iconSrc={timeline2007Img} yearDisplay="2007" displayOnLeft />
                <ContentBox title="We are the First!" content="Hotmob builds the first premium mobile ad network in Hong Kong." />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle, flexFlow: 'row-reverse' }}>
                <IconBox iconSrc={timeline2010Img} yearDisplay="2010" />
                <ContentBox
                    title="First Mover in the Market"
                    content="We keep innovating new ad formats.<br />E.g. HTML5, Pop Up ads, interactive ads"
                    displayOnLeft
                />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle }}>
                <IconBox yearDisplay="2013" displayOnLeft />
                <ContentBox title="Leveraging Big Data" content="We revolutionize digital advertising to deliver accurate ads." />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle, flexFlow: 'row-reverse' }}>
                <IconBox iconSrc={timeline2016Img} yearDisplay="2016" />
                <ContentBox
                    title="Years of Creation"
                    content="The launch of Alcanzar DSP & AdvanceEx Custom Audience Creations & DARTS Targeting."
                    displayOnLeft
                />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle }}>
                <IconBox yearDisplay="2018" displayOnLeft />
                <ContentBox
                    title="Data Enrichment"
                    content="Leading external data provider, enabling companies empower their own CRM’s and marketing channels."
                />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle, flexFlow: 'row-reverse' }}>
                <IconBox iconSrc={timeline2021Img} yearDisplay="2021" />
                <ContentBox
                    title="AudSec Launch"
                    content="Audience profiling segmentation and curation platform from media campaign."
                    displayOnLeft
                />
            </Box>
        </MaybeFade>
        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
            <img
                alt="timeline moving forward icon"
                loading="lazy"
                width="23"
                height="94"
                src={separator}
                style={{ width: '20px', height: 'auto' }}
            />
        </Box>
        <MaybeFade direction="down" fraction={0.8} triggerOnce>
            <Box sx={{ ...timelineRowStyle }}>
                <IconBox iconSrc={timeline2024Img} yearDisplay="2024" displayOnLeft />
                <ContentBox title="Caterpillar Launch" content="AI-powered tool facilitates creative generation and production." />
            </Box>
        </MaybeFade>
    </Box>
);

export default MobileView;
